import { Component, input } from '@angular/core';
import { Message } from '../../../services/chat-service/types';

@Component({
  selector: 'user-text-bubble',
  template: `
    <div class="chat-bubble">
      {{ message().content }}
    </div>
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: row-reverse;
    }

    div.chat-bubble {
      background: linear-gradient(135deg, #f7effd 0%, #f0f9fd 100%);
      border-radius: 16px 16px 4px 16px;
      padding: 11px 15px;
      font-size: 14px;
      font-family: var(--font);
      color: #1a1a2e;
      max-width: 76%;
      line-height: 1.55;
    }
  `,
})
export class UserTextBubble {
  readonly message = input.required<Message>();
}
